export default __webpack_public_path__ + "static/media/GO_LOCAL.671b90bc.png";